import { DEFAULT_CHANNEL } from './constants'

export default function normalizeEvent(message, channel = DEFAULT_CHANNEL) {
  return message.includes(':') ? message : `${channel}:${message}`
}
